import { Profile } from '@/types'
import  { queryClient } from '../queryClient'

export const QueryKeys = {
  me: queryClient.queryKey<Profile>(['me']),
  create: queryClient.queryKey(['createProfile']),
  update: queryClient.queryKey(['updateProfile']),
}
